// src/lib/errors/codes.ts

export const ErrorCodes = {
  // Student
  STUDENT_NAME_REQUIRED: "STUDENT_NAME_REQUIRED",
  STUDENT_NAME_DUPLICATE: "STUDENT_NAME_DUPLICATE",
  STUDENT_NAME_TOO_SHORT: "STUDENT_NAME_TOO_SHORT",
  STUDENT_NAME_TOO_LONG: "STUDENT_NAME_TOO_LONG",
  STUDENT_NOT_FOUND: "STUDENT_NOT_FOUND",
  STUDENT_GRADE_INVALID: "STUDENT_GRADE_INVALID",
  STUDENT_GENDER_INVALID: "STUDENT_GENDER_INVALID",
  STUDENT_SCHOOL_TOO_LONG: "STUDENT_SCHOOL_TOO_LONG",
  STUDENT_BIRTHDATE_OUT_OF_RANGE: "STUDENT_BIRTHDATE_OUT_OF_RANGE",
  PHONE_INVALID_FORMAT: "PHONE_INVALID_FORMAT",

  // Teacher
  TEACHER_NAME_REQUIRED: "TEACHER_NAME_REQUIRED",
  TEACHER_NAME_DUPLICATE: "TEACHER_NAME_DUPLICATE",
  TEACHER_NAME_TOO_SHORT: "TEACHER_NAME_TOO_SHORT",
  TEACHER_NAME_TOO_LONG: "TEACHER_NAME_TOO_LONG",
  TEACHER_EMAIL_INVALID: "TEACHER_EMAIL_INVALID",

  // Subject
  SUBJECT_NAME_REQUIRED: "SUBJECT_NAME_REQUIRED",
  SUBJECT_NAME_DUPLICATE: "SUBJECT_NAME_DUPLICATE",
  SUBJECT_NAME_TOO_SHORT: "SUBJECT_NAME_TOO_SHORT",
  SUBJECT_NAME_TOO_LONG: "SUBJECT_NAME_TOO_LONG",
  SUBJECT_NOT_FOUND: "SUBJECT_NOT_FOUND",

  // Academy
  ACADEMY_NAME_REQUIRED: "ACADEMY_NAME_REQUIRED",
  ACADEMY_NAME_TOO_SHORT: "ACADEMY_NAME_TOO_SHORT",
  ACADEMY_NAME_TOO_LONG: "ACADEMY_NAME_TOO_LONG",

  // Session
  SESSION_NOT_FOUND: "SESSION_NOT_FOUND",
  SESSION_TIME_INVALID: "SESSION_TIME_INVALID",
  SESSION_DURATION_EXCEEDED: "SESSION_DURATION_EXCEEDED",
  SESSION_DESCRIPTION_TOO_LONG: "SESSION_DESCRIPTION_TOO_LONG",
  SESSION_NOTE_TOO_LONG: "SESSION_NOTE_TOO_LONG",
  SESSION_WEEKDAY_INVALID: "SESSION_WEEKDAY_INVALID",
  SESSION_TEACHER_ID_REQUIRED: "SESSION_TEACHER_ID_REQUIRED",

  // Template
  TEMPLATE_NAME_REQUIRED: "TEMPLATE_NAME_REQUIRED",
  TEMPLATE_NAME_TOO_LONG: "TEMPLATE_NAME_TOO_LONG",
  TEMPLATE_DESCRIPTION_TOO_LONG: "TEMPLATE_DESCRIPTION_TOO_LONG",

  // ShareToken
  SHARE_TOKEN_LABEL_TOO_LONG: "SHARE_TOKEN_LABEL_TOO_LONG",
  SHARE_TOKEN_EXPIRES_INVALID: "SHARE_TOKEN_EXPIRES_INVALID",

  // UserSettings
  USER_SETTINGS_THEME_INVALID: "USER_SETTINGS_THEME_INVALID",
  USER_SETTINGS_LANGUAGE_INVALID: "USER_SETTINGS_LANGUAGE_INVALID",
  USER_SETTINGS_TIMEZONE_INVALID: "USER_SETTINGS_TIMEZONE_INVALID",

  // Color (entity-agnostic — teachers/subjects color 공통)
  COLOR_HEX_INVALID: "COLOR_HEX_INVALID",

  // Invite
  INVITE_TOKEN_EXPIRED: "INVITE_TOKEN_EXPIRED",
  INVITE_TOKEN_USED: "INVITE_TOKEN_USED",
  INVITE_ROLE_INVALID: "INVITE_ROLE_INVALID",
  INVITE_MEMBER_INSERT_FAILED: "INVITE_MEMBER_INSERT_FAILED",

  // Snapshot
  SNAPSHOT_TYPE_INVALID: "SNAPSHOT_TYPE_INVALID",
  SNAPSHOT_PAYLOAD_REQUIRED: "SNAPSHOT_PAYLOAD_REQUIRED",
  SNAPSHOT_DESCRIPTION_TOO_LONG: "SNAPSHOT_DESCRIPTION_TOO_LONG",
  SNAPSHOT_INSERT_FAILED: "SNAPSHOT_INSERT_FAILED",
  SNAPSHOT_LIST_FAILED: "SNAPSHOT_LIST_FAILED",
  SNAPSHOT_PERMISSION_DENIED: "SNAPSHOT_PERMISSION_DENIED",

  // General (HTTP 의미론적 범용 에러 — {ENTITY}_{FIELD}_{RULE} 세그먼트 예외 허용)
  VALIDATION_FAILED: "VALIDATION_FAILED",
  UNAUTHORIZED: "UNAUTHORIZED",
  FORBIDDEN: "FORBIDDEN",
  INTERNAL_ERROR: "INTERNAL_ERROR",
} as const;

export type ErrorCode = (typeof ErrorCodes)[keyof typeof ErrorCodes];
